"use client"

import { Fragment } from "react"
import { AtomComponents } from "./atoms"
import { BlocksComponents } from "./blocks"
import { newBlocks } from "./new-blocks"

const components: {
  [type: string]: any
} = {
  ...newBlocks,
  ...AtomComponents,
  ...BlocksComponents,
}

interface SanityContentsProps {
  contents: any[]
}

export const SanityContents = ({ contents }: SanityContentsProps) => {
  return (
    <>
      {contents
        ?.filter((x) => !x.options?.hidden)
        .map((x, i) => {
          const Component = components[x._type]

          if (!Component) {
            console.error("Cannot render component type", x._type, x)
            return <Fragment key={i}>Not found {x._type}</Fragment>
          }
          return <Component key={x._key} content={x} />
        })}
    </>
  )
}
